import './Loading.scss'

import { Container, Row, Spinner } from 'react-bootstrap'
import cn from 'classnames'

export default function Loading({
  isLoaded,
  children,
  loadingClass = '',
  hasContainer = true,
  style
}) {
  return (
    <>
      {isLoaded ? (
        <Container
          className={cn(loadingClass, { 'loader-container': hasContainer })}
          style={style}
        >
          <Row>
            <Spinner
              animation='border'
              role='status'
              variant='primary'
              size='lg'
            >
              <span className='visually-hidden'>Loading...</span>
            </Spinner>
          </Row>
        </Container>
      ) : (
        children
      )}
    </>
  )
}
